import { useSeoMeta } from "@unhead/react";
import { Link } from "react-router-dom";
import { CheckIcon } from "lucide-react";
import { Layout } from "@/components/Layout";
import { Button } from "@/components/ui/button";

/**
 * Landing page for the NIP-46 `callback` URL embedded in nostrconnect:// URIs
 * on mobile (see AuthDialog). After the user approves the connection in their
 * signer app (e.g. Amber), the signer redirects the browser here. The login
 * itself completes over the relay in the original tab — this page simply
 * confirms the approval and routes the user back into the app (instead of
 * landing on the 404 page).
 */
const RemoteLoginSuccessPage = () => {
  useSeoMeta({
    title: "Login Approved — Nostr Links",
    description: "Your signer approved the connection. Return to the app to continue.",
  });

  return (
    <Layout>
      <div className="flex-1 flex items-center justify-center py-20 px-4">
        <div className="text-center max-w-sm">
          <div className="flex size-16 bg-primary/10 rounded-full items-center justify-center mx-auto mb-6">
            <CheckIcon className="size-8 text-primary" />
          </div>
          <h1 className="text-2xl font-bold mb-3">Connection approved</h1>
          <p className="text-muted-foreground mb-8">
            Your signer approved the login. If you came from Amber, you can head
            back — you're logged in.
          </p>
          <Button asChild className="rounded-full">
            <Link to="/">Return to Nostr Links</Link>
          </Button>
        </div>
      </div>
    </Layout>
  );
};

export default RemoteLoginSuccessPage;
